import React from "react";

const DeleteModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <React.Fragment>
      <div className="modal-overlay">
        <div className="outline" onClick={() => props.Close()}></div>
        <main className="modal-content">
          <section className="modal-head">
            <h1 className="modal-title">
              {translateText("delete_conversation")}
            </h1>
            <i className="feather-x" onClick={() => props.Close()}></i>
          </section>
          <section className="modal-alert">
            <span className="modal-alert-text">
              {translateText("icp_delete_conversation_text_1") + " "}
              <strong className="strong">
                {" " + props.ConversationInfo.recipient_name + " "}
              </strong>{" "}
              {translateText("icp_delete_conversation_text_2") + " "}
              <strong className="strong">
                {" " + props.ConversationInfo.jpa_name + " "}
              </strong>
            </span>
          </section>
          <section className="modal-actions">
            <span className="cancel" onClick={() => props.Close()}>
              {translateText("cancel")}
            </span>
            <span
              className="confirm-delete"
              onClick={() => props.AcceptDelete()}
            >
              {translateText("delete")}
            </span>
          </section>
        </main>
      </div>
    </React.Fragment>
  );
};

export default DeleteModal;
